export interface HintText {
  title: string;
  content: string;
}

export class HintContents {
  public static ECO_MODE: HintText = {
    title: 'Save the planet!',
    content: 'Your home’s temperature will be set to 68 in the winter and 75 in the summer. Eco-mode will override your sleep and wake settings. '
  }

  public static SYNC_UNITS: HintText = {
    title: 'Sync',
    content: 'Sync the temperature on all your devices.'
  }

  public static CONSUMPTION: HintText = {
    title: 'Stay In-the-Know',
    content: 'Track how much water and energy you’re using.'
  }

  public static SOMEONES_HOME: HintText = {
    title: 'Going away?',
    content: 'When your system is armed, this randomly turns your lights on and off so your apartment looks lived-in while you’re away. It only handles the lights and doesn’t monitor your home or send alerts.'
  }

  public static ALARM_TIMER: HintText = {
    title: 'Give yourself time',
    content: 'Set how much time you want between setting the alarm and your apartment arming.  '
  }

  public static PET_MODE: HintText = {
    title: 'Have a pet at home?',
    content: 'When you leave, your home won’t switch to energy-saving temperatures. Heating and cooling keep following your own settings and schedule. Temperature safety limits still apply.'
  }

  public static SANITIZATION: HintText = {
    title: 'Clean while you’re away!',
    content: 'UV-C light will eliminate bacteria and pathogens in your Spa suite and kitchen.'
  }

  public static SHOWER_SAVER: HintText = {
    title: 'Conserve water',
    content: 'Set an audio notification for when you’ve been in the shower for a certain amount of time.  '
  }

  public static NIGHT_LIGHT: HintText = {
    title: 'Light the way!',
    content: 'Illuminate your Spa Suite after the sun goes down.  '
  }

  public static AUTO_ON_LIGHT: HintText = {
    title: 'You got motion!',
    content: 'Choose rooms to turn on lights when you’re on the move. '
  }

  public static AUTO_OFF_LIGHT: HintText = {
    title: 'No movement?',
    content: 'Auto Off will turn the lights off when no movement is detected.'
  }

  public static CIRCADIAN_LIGHT: HintText = {
    title: 'Follow the sun’s natural rhythm',
    content: 'If turned on, the temperature of your white lights will shift in unison with the sun, warm at dawn and dusk, and bright during the day.'
  }

  public static PAIR_MODE: HintText = {
    title: 'Pairing Mode!',
    content: 'To pair your phone with your home, enable pairing and select the speaker in the Bluetooth settings of your phone.'
  }

  public static THEME: HintText = {
    title: 'Appearance',
    content: 'Choose how the app looks. Light uses a white background, Dark uses a black background, and Auto follows your device settings.'
  }

  public static UPDATE_IOS: HintText = {
    title: 'Critical Update Available',
    content: 'A new critical update is available from the App Store. Please update the App to ensure optimal performance.',
  }

  public static UPDATE_ANDROID: HintText = {
    title: 'Critical Update Available',
    content: 'A new critical update is available from the Play Market. Please update the App to ensure optimal performance.',
  }

  public static UPDATE_OTHER: HintText = {
    title: 'Critical Update Available',
    content: 'A new critical update is available. Please reload the page to ensure optimal performance.',
  }

  public static PACKAGE_ALERTS: HintText = {
    title: 'You\'ve Got Mail',
    content: 'Receive notifications when packages are delivered and picked up.'
  }

  public static WEATHER_ALERTS: HintText = {
    title: 'Stay Safe',
    content: 'Get notified when the National Weather Service issues a tornado, hurricane, flood, or blizzard warning for your building.'
  }
}
